import {
  createAction,
  joinActions,
  props,
} from "../../helpers/store/actions-helpers";
import { EmailTemplate } from "../interfaces/api/get-email-templates";
import { SocialTemplate } from "../interfaces/api/get-social-templates";

export const postEmailTemplateInitAction = createAction(
  "[Template] Post Email Template Init"
);
export const postEmailTemplateSuccessAction = createAction(
  "[Template] Post Email Template Success",
  props< { template: EmailTemplate } >()
);
export const postEmailTemplateFailureAction = createAction(
  "[Template] Post Email Template Failure",
  props<{ error: string }>()
);

export const postSocialTemplateInitAction = createAction(
  "[Template] Post Social Template Init"
);
export const postSocialTemplateSuccessAction = createAction(
  "[Template] Post Social Template Success",
  props< { template: SocialTemplate } >()
);
export const postSocialTemplateFailureAction = createAction(
  "[Template] Post Social Template Failure",
  props<{ error: string }>()
);

export const putEmailTemplateInitAction = createAction(
  "[Template] Put Email Template Init"
);
export const putEmailTemplateSuccessAction = createAction(
  "[Template] Put Email Template Success",
  props< { template: EmailTemplate } >()
);
export const putEmailTemplateFailureAction = createAction(
  "[Template] Put Email Template Failure",
  props<{ error: string }>()
);

export const putSocialTemplateInitAction = createAction(
  "[Template] Put Social Template Init"
);
export const putSocialTemplateSuccessAction = createAction(
  "[Template] Put Social Template Success",
  props< { template: SocialTemplate } >()
);
export const putSocialTemplateFailureAction = createAction(
  "[Template] Put Social Template Failure",
  props<{ error: string }>()
);

export const getEmailTemplatesInitAction = createAction(
  "[Template] Get Email Templates Init"
);
export const getEmailTemplatesSuccessAction = createAction(
  "[Template] Get Email Templates Success",
  props< { templates: EmailTemplate[] } >()
);
export const getEmailTemplatesFailureAction = createAction(
  "[Template] Get Email Templates Failure",
  props<{ error: string }>()
);

export const getSocialTemplatesInitAction = createAction(
  "[Template] Get Social Templates Init"
);
export const getSocialTemplatesSuccessAction = createAction(
  "[Template] Get Social Templates Success",
  props< { templates: SocialTemplate[] } >()
);
export const getSocialTemplatesFailureAction = createAction(
  "[Template] Get Social Templates Failure",
  props<{ error: string }>()
);

export const deleteEmailTemplateInitAction = createAction(
  "[Template] Delete Email Template Tag Init"
);
export const deleteEmailTemplateSuccessAction = createAction(
  "[Template] Delete Email Template Tag Success",
  props< { id: string } >()
);
export const deleteEmailTemplateFailureAction = createAction(
  "[Template] Delete Email Template Tag Failure",
  props<{ error: string }>()
);

export const deleteSocialTemplateInitAction = createAction(
  "[Template] Delete Social Template Tag Init"
);
export const deleteSocialTemplateSuccessAction = createAction(
  "[Template] Delete Social Template Tag Success",
  props< { id: string } >()
);
export const deleteSocialTemplateFailureAction = createAction(
  "[Template] Delete Social Template Tag Failure",
  props<{ error: string }>()
);

const actions = joinActions({
  postEmailTemplateInitAction,
  postEmailTemplateSuccessAction,
  postEmailTemplateFailureAction,
  putEmailTemplateInitAction,
  putEmailTemplateSuccessAction,
  putEmailTemplateFailureAction,
  getEmailTemplatesInitAction,
  getEmailTemplatesSuccessAction,
  getEmailTemplatesFailureAction,
  deleteEmailTemplateInitAction,
  deleteEmailTemplateSuccessAction,
  deleteEmailTemplateFailureAction,
  postSocialTemplateInitAction,
  postSocialTemplateSuccessAction,
  postSocialTemplateFailureAction,
  putSocialTemplateInitAction,
  putSocialTemplateSuccessAction,
  putSocialTemplateFailureAction,
  getSocialTemplatesInitAction,
  getSocialTemplatesSuccessAction,
  getSocialTemplatesFailureAction,
  deleteSocialTemplateInitAction,
  deleteSocialTemplateSuccessAction,
  deleteSocialTemplateFailureAction,
});

export type TemplateApiAction = typeof actions;
